var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchCategoryBlockchain16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture-Category/16/Blockchain_16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linear-gradient-aws/Category-Icons/Arch-Category_16/Arch-Category_Blockchain_16.svg"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8511B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-Category/16/Blockchain_16",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linear-gradient-aws/Category-Icons/Arch-Category_16/Arch-Category_Blockchain_16.svg)",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "#879196-Border-Copy-4",
    stroke: "#879196",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Category/16/Blockchain_16",
    transform: "translate(9.000000, 8.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,9 L15,9 L15,7 L13,7 L13,9 Z M7,9 L9,9 L9,7 L7,7 L7,9 Z M1,9 L3,9 L3,7 L1,7 L1,9 Z M12,7.5 L10,7.5 L10,6 L6,6 L6,7.5 L4,7.5 L4,6 L0,6 L0,10 L4,10 L4,8.5 L6,8.5 L6,10 L10,10 L10,8.5 L12,8.5 L12,10 L16,10 L16,6 L12,6 L12,7.5 Z",
    id: "Blockchain_Category-Icon_16_Squid--"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchCategoryBlockchain16);
export default __webpack_public_path__ + "static/media/Arch-Category_Blockchain_16.99e530a2ddb8defd2bf1609455e17307.svg";
export { ForwardRef as ReactComponent };